<svelte:options accessors={true} />

<script>
    export let title=''
    export let id=''
    export let value=''
    export let customSlot = false
    export let copyAllow = true
    let copyProcess = false
    let input

    async function copy() {
        copyProcess = true
        input.select();
        document.execCommand("Copy");
        await sleep(1500)
        input.blur()
        copyProcess = false
    }
</script>

<div class="row">
    <div class="col-4 align-middle">
        {title}:
    </div>
    <div class="col align-middle">
            {#if customSlot}
                <slot/>
            {:else}
            <div class="input-group mb-1">
                <input bind:this={input} type="text" class="form-control" aria-describedby="button-addon-{id}" readonly="readonly" value={value} />
                {#if copyAllow}
                    <button on:click={copy} class="btn btn-outline-secondary" type="button" id="button-addon-{id}">
                        {#if !copyProcess}
                            ✂️
                        {:else}
                            скопировано
                        {/if}
                    </button>
                {/if}
            </div>
            {/if}
        
    </div>
</div>